export default function ContactSection() {
  return (
    <section id="contact" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="max-w-2xl mx-auto text-center">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-secondary-100 text-secondary-700 text-xs font-medium mb-4">
            <i className="ri-mail-line"></i>
            联系我们
          </div>
          <h2 className="font-heading text-2xl md:text-4xl text-foreground-950 mb-3">
            联系我们
          </h2>
          <p className="text-foreground-600 text-sm md:text-base mb-8">
            有好看的影视资源推荐？有剧集更新线索？欢迎联系我们投稿或反馈
          </p>

          <div className="bg-background-50 rounded-2xl p-6 md:p-8 border border-background-200/70">
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-6">
              <div className="text-center">
                <div className="w-12 h-12 mx-auto mb-3 rounded-xl bg-primary-100 flex items-center justify-center">
                  <i className="ri-mail-send-line text-primary-500 text-xl"></i>
                </div>
                <h3 className="text-foreground-950 font-medium text-sm mb-1">投稿邮箱</h3>
                <p className="text-foreground-600 text-xs">contact@nencao.com</p>
              </div>
              <div className="text-center">
                <div className="w-12 h-12 mx-auto mb-3 rounded-xl bg-accent-100 flex items-center justify-center">
                  <i className="ri-wechat-line text-accent-500 text-xl"></i>
                </div>
                <h3 className="text-foreground-950 font-medium text-sm mb-1">微信客服</h3>
                <p className="text-foreground-600 text-xs">nencaovideo</p>
              </div>
              <div className="text-center">
                <div className="w-12 h-12 mx-auto mb-3 rounded-xl bg-secondary-100 flex items-center justify-center">
                  <i className="ri-feedback-line text-secondary-500 text-xl"></i>
                </div>
                <h3 className="text-foreground-950 font-medium text-sm mb-1">意见反馈</h3>
                <p className="text-foreground-600 text-xs">在线提交反馈表</p>
              </div>
            </div>

            <div className="mt-8 pt-6 border-t border-background-200">
              <p className="text-foreground-500 text-xs">
                工作日 9:00-18:00 在线响应，投稿内容审核通过后将标注来源并致谢
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}